import "./HowToPlayPart.css";

const HowToPlayPart = () => {
  return (
    <section className="pad pad-top flex">
      <h2>How to Play</h2>
      <ul className="lottolegenda-grid-4">
        <li className="lottolegenda-how-part__list-item line">
          <p className="t-21 fw-700 lottolegenda-how-part__list-header">
            Pick Your Numbers
          </p>
          <p>
            Choose 6 main numbers from 1 to 48 and 1 Viking number from 1 to 5.
          </p>
        </li>
        <li className="lottolegenda-how-part__list-item line">
          <p className="t-21 fw-700 lottolegenda-how-part__list-header">
            Ticket Price
          </p>
          <p>
            The price per ticket varies slightly by country, typically around €2
            to €3.
          </p>
        </li>
        <li className="lottolegenda-how-part__list-item line">
          <p className="t-21 fw-700 lottolegenda-how-part__list-header">
            Draw Days
          </p>
          <p>
            Draws are held every Wednesday at 20:00 CET.Draws are held every
            Wednesday at 20:00 CET.
          </p>
        </li>
        <li className="lottolegenda-how-part__list-item line">
          <p className="t-21 fw-700 lottolegenda-how-part__list-header">
            Play Options
          </p>
          <p>
            You can play online via official lottery websites or in-store at
            licensed retail locations in participating countries.
          </p>
        </li>
      </ul>
    </section>
  );
};

export default HowToPlayPart;
